import { render } from "./UploaderMediaIcon.vue?vue&type=template&id=7be39f8a"
import script from "./UploaderMediaIcon.vue?vue&type=script&lang=js"
export * from "./UploaderMediaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__